import { API_URL } from '../../../app-config/constants';
import { Reminder, SummaryResponse } from '../../../types/SummaryAssistant';
import { get, post } from '../request';

const BASE_URL = `${API_URL}/summary-assistant`;

type SummaryType = 'FIND_CORE_POINTS' | 'REGENERATE_ONE_POINT';

export function getPromptResult(
    id: string,
    type: SummaryType,
    options?: { regenerate: number }
): Promise<SummaryResponse> {
    return post(BASE_URL, { postData: { type, id, ...options } });
}

regenerate.operation = 'COMMAND';
export function regenerate(keyTakeawayId: string, summaryResponse: SummaryResponse): Promise<SummaryResponse> {
    return post(`${BASE_URL}/regenerate/${keyTakeawayId}`, { postData: summaryResponse });
}

getSummary.operation = 'READ';
export function getSummary(id: string): Promise<SummaryResponse> {
    return get(`${BASE_URL}/${id}`);
}

save.operation = 'COMMAND';
export function save(summaryResponse: SummaryResponse): Promise<SummaryResponse> {
    return post(`${BASE_URL}/save`, { postData: summaryResponse });
}

export function getQuotaTokens(): Promise<number> {
    return get(`${BASE_URL}/tokens`);
}

interface ReminderRequest {
    date: string;
}

scheduleReminder.operation = 'NO_OPERATION';
scheduleReminder.invalidates = ['getSummary'];
export function scheduleReminder(assessmentId: string, request: ReminderRequest): Promise<Reminder> {
    return post(`${BASE_URL}/${assessmentId}/reminders`, { postData: request });
}
